module.exports = __webpack_public_path__ + "static/img/gx.c6f4542.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s29/gx.png
// module id = /+RZ
// module chunks = 2